import React, { createContext, useState, useEffect, ReactNode } from 'react';

interface ClockContextType {
  currentTime: Date;
}

const ClockContext = createContext<ClockContextType | undefined>(undefined);

const ClockProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000); // Update every second
    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  return (
    <ClockContext.Provider value={{ currentTime }}>
      {children}
    </ClockContext.Provider>
  );
};

const useClock = () => {
  const context = React.useContext(ClockContext);
  if (context === undefined) {
    throw new Error('useClock must be used within a ClockProvider');
  }
  return context;
};

export { ClockProvider, useClock };
